export const getSubdomain = () => {
    const hostname = location.hostname; // e.g. "client-platform.mydomain.com"
    const parts = hostname.split('.');

    // Handle subdomains like client-platform.mydomain.com
    if (parts.length > 2) {
        return parts[0]; // returns "client-platform"
    }

    // No subdomain present
    return null;
}